import { render, staticRenderFns } from "./hot.vue?vue&type=template&id=ea15cf6c&scoped=true"
import script from "./hot.vue?vue&type=script&lang=js"
export * from "./hot.vue?vue&type=script&lang=js"
import style0 from "./hot.vue?vue&type=style&index=0&id=ea15cf6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea15cf6c",
  null
  
)

export default component.exports